export const shareOnFacebook = (key: string) => {
    const url = encodeURIComponent(`https://road2recharge.com/leaderboard?key=${key}`);
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;

    const width = 1200;
    const height = 630;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    window.open(
      shareUrl,
      "Facebook Share",
      `width=${width},height=${height},left=${left},top=${top},toolbar=0,status=0`
    );
  };

  export const shareOnTwitter = (key: string) => {
    const text = encodeURIComponent("Check out my score on the Road to Recharge leaderboard!");
    const url = encodeURIComponent(`https://road2recharge.com/leaderboard?key=${key}`);
    const hashtags = "EV,electricvehiclecharging,EversourceRoadtoRecharge"; // optional

    const shareUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}&hashtags=${hashtags}`;

    const width = 800;
    const height = 600;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    window.open(
      shareUrl,
      "Twitter Share",
      `width=${width},height=${height},left=${left},top=${top},toolbar=0,status=0`
    );
  };

  export const shareOnLinkedIn = (key: string) => {
    const url = encodeURIComponent(`https://road2recharge.com/leaderboard?key=${key}`);
    const title = encodeURIComponent("Eversource: Road to Recharge");
    const summary = encodeURIComponent(
      "Check out my score on the Road to Recharge leaderboard!"
    );
    const source = encodeURIComponent("road2recharge.com");
  
    const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}&title=${title}&summary=${summary}&source=${source}`;
  
    const width = 800;
    const height = 600;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
  
    window.open(
      shareUrl,
      "LinkedIn Share",
      `width=${width},height=${height},left=${left},top=${top},toolbar=0,status=0`
    );
  };